<template>
  <div id="app">
    <header>
      <div class="row no-gutters">
        <div class="col logo">
          <img src="@/assets/theme/lsxvip.png">
        </div>
        <div class="col top-menu">
          <button class="btn btn-sm mx-1">Career</button>
          <button class="btn btn-sm mx-1">Sitemap</button>
          <button class="btn btn-sm mx-1">ລາວ</button>
        </div>
      </div>
    </header>
    <div class="main-menu">
      <ul>
        <li>Home</li>
        <li>About LSX</li>
        <li>Laws/Regulstions</li>
        <li>Products/Services</li>
        <li>Market Data</li>
        <li>Listed Companies/Disclosure</li>
      </ul>
    </div>
    <div style="font-size: 85%;">
      <marquee id="ticker" onmouseover="this.stop()" onmouseout="this.start()" scrolldelay="200">Date: {{date}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LSX Composite Index: {{ close | amountFormat }}&nbsp;<img v-if="isUp" src="@/assets/theme/ico_up.gif"><img v-else-if="isDown" src="@/assets/theme/ico_down.gif"><font :class="[{'text-success': isUp}, {'text-danger': isDown}]">{{change}}</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Price (BCEL: 4,200&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EDL-Gen: 2,170&nbsp;<img src="@/assets/theme/ico_up.gif"><font color="green">20</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PTL: 1,170&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SVN: 2,750&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PCD: 1,350&nbsp;<img src="@/assets/theme/ico_down.gif"><font color="red">-50</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LCC: 1,090&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MHTL: 445&nbsp;<img src="@/assets/theme/ico_down.gif"><font color="red">-5</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LAT: 840&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;VCL: 1,080&nbsp;<img src="@/assets/theme/ico_up.gif"><font color="green">90</font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LALCO: 23,000)</marquee>
    </div>
    <div class="the-content">
      <div class="main-content">
        <router-view/>
      </div>
      <div class="the-sidebar">
        <Sidebar />
      </div>
      <div class="clearfix"></div>
    </div>
    <!-- <Banners class="mb-5" /> -->
    <ListCompany />
    <Footer />
  </div>
</template>
<script>
import Footer from './views/components/Footer'
import ListCompany from './views/components/ListCompany'
import Sidebar from './views/components/Sidebar'
import moment from '@/moment'

export default {
  components: {
    // LastPriceIndex,
    Footer,
    ListCompany,
    // Banners,
    Sidebar
  },
  computed: {
    price() {
      return this.$store.getters.getPrice
    },
    date() {
      return moment(this.price.time).format("DD/MM/YYYY")
    },
    close() {
      return this.price?.close || 0
    },
    change() {
      return this.price?.change || 0
    },
    isUp() {
      return this.price.open < this.price.close
    },
    isDown() {
      return this.price.open > this.price.close
    }
  },
  created() {
    //console.log('moment', this.$moment())
  }
}
</script>
<style lang="scss">
  /* Import Font Awesome 5 Icons Set */
  $fa-font-path: '~@fortawesome/fontawesome-free/webfonts';
  @import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
  @import '~@fortawesome/fontawesome-free/scss/solid.scss';
  @import '~@fortawesome/fontawesome-free/scss/regular.scss';
  @import '~@fortawesome/fontawesome-free/scss/brands.scss';

body {
  margin: 0;
  padding: 0;
}

#app {
  width: 900px;
  margin: 0 auto;

  header {
    background-color: #FFFFFF;
    border-bottom: 1px solid #FFFFFF;

    .logo {
      padding: 5px 10px;

      img {
        height: 40px;
      }
    }

    .top-menu {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      button {
        padding: 0px 5px;
        border: 1px solid #EEEEEE;
        background-color: #E7E9EB;
      }
    }
  }

  .main-menu {
    background-color: #A00024;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;

    ul {
      padding: 4px 0px;
      margin: 0;
      display: flex;
      justify-content: space-around;

      li {
        list-style: none;
        color: #FFFFFF;
        padding: 2px 8px;
        cursor: pointer;
        font-size: 95%;
      }

      li:hover {
        background-color: #910223;
      }
    }
  }

  .the-content {
    margin: 15px 0;

    .main-content {
      float: left;
      width: 550px;
    }

    .the-sidebar {
      float: right;
      width: 330px;
    }
  }
}
</style>
